import React, { useState, ChangeEvent, FormEvent } from 'react';

import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { MobileTimePicker } from '@mui/x-date-pickers/MobileTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/es';

import {
    TextField,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Button,
    InputAdornment,
    Grid,
} from '@mui/material';
import dayjs from 'dayjs';
import { PaycodeAssignEmployeeItem, PaycodeItem } from 'pages/web/userManagement/subpages/profiles/type';

const clearItem: PaycodeAssignEmployeeItem = {
    date: dayjs(),
    id_paycode: 0,
    amount: '0.0',
    id_employee: 0,
    start: dayjs(),
    note: '',
    comment: '',
    template: '',
};

interface FormProps {
    onSubmit: (item: PaycodeAssignEmployeeItem) => void;
    item?: PaycodeAssignEmployeeItem;
    ActionButton: React.ReactNode;
    onCancel: () => void;
    items: PaycodeItem[];
}

export const Form: React.FC<FormProps> = ({ onSubmit, item = clearItem, ActionButton, onCancel, items }) => {

    const [form, setForm] = useState(() => {
        if (!item.hasOwnProperty('date')) {
            return {
                ...clearItem,
                id_employee: item.id_employee,
            };
        }
        return{
            ...item,
            date: dayjs(item.date),
            start: dayjs(`${item.date} ${item.start}`),
        }

    })

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        const { name, value, type, checked } = event.target;
        setForm({
            ...form,
            [name]: type === 'checkbox' ? checked : value,
        });
    };

    const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        console.log(form);
        const data = {
            ...form,
            date: form.date.format('YYYY-MM-DD'),
            start: form.start.format('HH:mm'),
        }
        onSubmit(data);
    };


    return (
        <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
                {/* Fecha de vigencia */}
                <Grid size={{ xs: 12 }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                        <FormControl fullWidth>
                            <MobileDatePicker
                                defaultValue={dayjs()}
                                label="Fecha de vigencia"
                                value={form.date}
                                onChange={(newValue) => setForm({...form, date: newValue})}
                            />
                        </FormControl>
                    </LocalizationProvider>
                </Grid>

                {/* Código de pago */}
                <Grid size={{ xs: 12 }}>
                    <FormControl fullWidth>
                        <InputLabel>Código de pago</InputLabel>
                        <Select
                            name="id_paycode"
                            value={form.id_paycode}
                            onChange={() => handleChange}
                        >
                            {items.map((item) => (
                                <MenuItem key={item.paycode_id} value={item.paycode_id}>
                                    {item.name}
                                </MenuItem>
                            ))}
                            {/* Agrega más opciones aquí */}
                        </Select>
                    </FormControl>
                </Grid>

                {/* Hora de inicio */}
                <Grid size={{ xs: 6 }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                        <FormControl fullWidth>
                            <MobileTimePicker
                                defaultValue={dayjs()}
                                label="Hora de inicio"
                                value={form.start}
                                onChange={(newValue) => setForm({...form, start: newValue})}
                            />
                        </FormControl>
                    </LocalizationProvider>
                </Grid>


                {/* Cantidad y Horas */}
                <Grid size={{ xs: 6 }}>
                    <FormControl fullWidth>
                        <TextField
                        id="amount"
                        label="Cantidad"
                        type="number"
                        name="amount"
                        defaultValue="0.0"
                        value={form.amount}
                        slotProps={{
                            input: {
                                endAdornment: <InputAdornment position="end">horas</InputAdornment>,
                            },
                            htmlInput:{
                                min: "0",
                                step: "0.1"
                            }
                        }}
                        onChange={handleChange}
                        />
                    </FormControl>
                </Grid>

                {/* Nota */}
                <Grid size={{ xs: 12 }}>
                        <FormControl fullWidth>
                            <TextField
                                name="note"
                                label="Nota"
                                value={form.note}
                                multiline
                                rows={4}
                                onChange={handleChange}
                            />
                        </FormControl>
                </Grid>

                {/* Comment */}
                <Grid size={{ xs: 12 }}>
                        <FormControl fullWidth>
                            <TextField
                                name="comment"
                                label="Comment"
                                value={form.comment}
                                multiline
                                rows={4}
                                onChange={handleChange}
                            />
                        </FormControl>
                </Grid>


                {/* Botones */}
                <Grid size={12} style={{ textAlign: 'right' }}>
                    <Button
                        variant="contained"
                        color="error"
                        type="submit"
                        style={{ marginRight: 8 }}
                    >
                        Guardar
                    </Button>
                    <Button variant="outlined" color="secondary">
                        Cancelar
                    </Button>
                </Grid>
            </Grid>

            {JSON.stringify(form)}
        </form>
    );
};